import { useEffect } from "react";
import * as Styled from "./style";
import { EXTERNAL_PATHS } from "~/const/paths";
import { sendTrackingSelectOrViewPromotion } from "~/lib/tracking/events";
import { uriConverter } from "~/util/uri-converter";

export const PremiumAppealBanner = () => {
  const backUrl = uriConverter.encode(location.href);
  const premiumRegistrationPageUrl = `${EXTERNAL_PATHS.REGISTRATION}${backUrl}`;

  useEffect(() => {
    sendTrackingSelectOrViewPromotion({
      creativeName: "banner",
      promotionId: "join_group_premium_intent",
      promotionName: "DMMプレミアム・30日間無料トライアル",
      locationId: "purchase_modal",
      isView: true,
    });
  }, []);

  return (
    <Styled.ButtonActionWrapper
      type="button"
      name="プレミアム入会導線ボタン"
      aria-label="プレミアム入会導線ボタン"
      onClick={() => {
        sendTrackingSelectOrViewPromotion({
          creativeName: "banner",
          promotionId: "join_group_premium_intent",
          promotionName: "DMMプレミアム・30日間無料トライアル",
          locationId: "purchase_modal",
        });
        location.href = premiumRegistrationPageUrl;
      }}
    >
      <Styled.GridContainer>
        <Styled.DivSummaryWrapper>
          <Styled.ParSubSummary>＼DMMプレミアムなら／</Styled.ParSubSummary>
          <Styled.ParSummary>無料登録後すぐに550pt獲得！</Styled.ParSummary>
          <Styled.ParSummary>550円お得に購入できる！</Styled.ParSummary>
        </Styled.DivSummaryWrapper>
        <Styled.AnchorPurchase>登録特典を利用して購入</Styled.AnchorPurchase>
      </Styled.GridContainer>
    </Styled.ButtonActionWrapper>
  );
};
